import {useRef, useEffect} from 'react'
//https://medium.com/@pdx.lucasm/canvas-with-react-js-32e133c05258
const useCanvas = (draw, options = {}) => {

	const canvasRef = useRef(null)

	const onClick = (event) => {
		if (typeof options.onClick === 'function') {
			options.onClick(event);
		}
	};

	const onDown = (event) => {
		if (typeof options.onDown === 'function') {
			options.onDown(event);
		}
	};

	const onUp = (event) => {
		if (typeof options.onUp === 'function') {
			options.onUp(event);
		}
	};

	const onMove = (event) => {
		if (typeof options.onMove === 'function') {
			options.onMove(event);
		}
	};

	useEffect(() => {

		const canvas = canvasRef.current
		const context = canvas.getContext('2d')
		let frameCount = 0
		//let animationFrameId
		const render = () => {
			//frameCount++
			draw(context, frameCount, canvas)
			//animationFrameId = window.requestAnimationFrame(render)
		}
		render()

		return () => {
			//window.cancelAnimationFrame(animationFrameId)
		}
	}, [draw]);


	useEffect(() => {
		const canvas = canvasRef.current
		canvas.addEventListener('click', onClick, false);
		canvas.addEventListener('mousemove', onMove, false);
		canvas.addEventListener('mouseup', onUp, false);
		canvas.addEventListener('mousedown', onDown, false);

		return () => {
			//window.cancelAnimationFrame(animationFrameId)
			canvas.removeEventListener('click', onClick);
			canvas.removeEventListener('mousemove', onMove);
			canvas.removeEventListener('mouseup', onUp);
			canvas.removeEventListener('mousedown', onDown);
		}
	}, [onClick, onMove, onUp, onDown]);

	return canvasRef
}

export default useCanvas
